var _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.9572,
    cy: 12.1973,
    r: 9,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9272 12.9473H15.1572H10.4872V15.7773H11.7972H15.9272C16.8772 15.7773 17.6572 15.1373 17.6572 14.3573C17.6572 13.5773 16.8772 12.9473 15.9272 12.9473Z",
    fill: "#F7931A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9572 2.19727C7.43718 2.19727 2.95718 6.67727 2.95718 12.1973C2.95718 17.7173 7.43718 22.1973 12.9572 22.1973C18.4772 22.1973 22.9572 17.7173 22.9572 12.1973C22.9572 6.67727 18.4772 2.19727 12.9572 2.19727ZM15.9272 17.2773H14.2772V18.6973C14.2772 19.1073 13.9372 19.4473 13.5272 19.4473C13.1172 19.4473 12.7772 19.1073 12.7772 18.6973V17.2773H11.7972H11.5672V18.6973C11.5672 19.1073 11.2272 19.4473 10.8172 19.4473C10.4072 19.4473 10.0672 19.1073 10.0672 18.6973V17.2773H9.73718H8.00718C7.59718 17.2773 7.25718 16.9373 7.25718 16.5273C7.25718 16.1173 7.59718 15.7773 8.00718 15.7773H8.98718V12.1973V8.61727H8.00718C7.59718 8.61727 7.25718 8.27727 7.25718 7.86727C7.25718 7.45727 7.59718 7.11727 8.00718 7.11727H9.73718H10.0672V5.69727C10.0672 5.28727 10.4072 4.94727 10.8172 4.94727C11.2272 4.94727 11.5672 5.28727 11.5672 5.69727V7.11727H11.7972H12.7772V5.69727C12.7772 5.28727 13.1172 4.94727 13.5272 4.94727C13.9372 4.94727 14.2772 5.28727 14.2772 5.69727V7.11727H15.1572C16.7072 7.11727 18.0772 8.47727 18.0772 10.0373C18.0772 10.7073 17.8372 11.3173 17.4572 11.8173C18.4672 12.3073 19.1572 13.2673 19.1572 14.3773C19.1572 15.9673 17.7072 17.2773 15.9272 17.2773Z",
    fill: "#F7931A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5772 10.0273C16.5772 9.3673 15.9572 8.6073 15.1572 8.6073H11.7972H10.4872V11.4373H15.1572C15.9372 11.4473 16.5772 10.8073 16.5772 10.0273Z",
    fill: "#F7931A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtc);
export default __webpack_public_path__ + "static/media/BTC.48804116b91cb4fe7097d805914e1847.svg";
export { ForwardRef as ReactComponent };